export const deleteChannelSuccess = {
  title: 'Updated',
};
